import { AdminPermissionDto } from "./admin-permission-dto";
import { AppUserDto } from "./app-user-dto";
import { FileDocumentDto } from "./file-document-dto";

export class ProctoringDataDto {
    imageData?: FileDocumentDto;
    adminPermissions?: AdminPermissionDto;
    appUserDto?: AppUserDto;
    ipAddress?: string;
    location?: string;
    focusInCount?: number;
    focusOutCount?: number;
}
